import { Controller } from "@hotwired/stimulus";

export class TabsController extends Controller {
  static targets = ["tab", "panel"];
  static values = {
    activeClass: { type: String, default: "active" },
  };

  connect() {
    this.showTab(0);
  }

  switch(event) {
    event.preventDefault();
    const index = this.tabTargets.indexOf(event.currentTarget);
    if (index >= 0) {
      this.showTab(index);
    }
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle(this.activeClassValue, i === index);
      tab.setAttribute("aria-selected", i === index ? "true" : "false");
    });
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}
